import { render, staticRenderFns } from "./HandoffRulesTab.vue?vue&type=template&id=4eb954da&scoped=true&"
import script from "./HandoffRulesTab.vue?vue&type=script&lang=js&"
export * from "./HandoffRulesTab.vue?vue&type=script&lang=js&"
import style0 from "./HandoffRulesTab.vue?vue&type=style&index=0&id=4eb954da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb954da",
  null
  
)

export default component.exports